import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  const openLegalPage = (page: string) => {
    // Just change hash, scroll position is handled in App.tsx
    window.location.hash = `#/${page}`;
  };

  return (
    <footer className="bg-white-cream/50 backdrop-blur-lg border-t border-wood-warm/30 mt-auto shadow-xl">
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-10 lg:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-6 md:gap-8 mb-6 sm:mb-8">
          {/* Company Info */}
          <div>
            <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-charcoal-dark">
              {t('footer.company.title', { defaultValue: 'Company' })}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-charcoal-medium">
              <li>
                <button
                  onClick={() => openLegalPage('company')}
                  className="hover:text-green-dark transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.company.about', { defaultValue: 'About Us' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('contact')}
                  className="hover:text-green-dark transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.company.contact', { defaultValue: 'Contact' })}
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-charcoal-dark">
              {t('footer.legal.title', { defaultValue: 'Legal' })}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-charcoal-medium">
              <li>
                <button
                  onClick={() => openLegalPage('privacy')}
                  className="hover:text-green-dark transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.legal.privacy', { defaultValue: 'Privacy Policy' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('terms')}
                  className="hover:text-green-dark transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.legal.terms', { defaultValue: 'Terms of Service' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('accessibility')}
                  className="hover:text-green-dark transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.legal.accessibility', { defaultValue: 'Accessibility' })}
                </button>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-charcoal-dark">
              {t('footer.customer.title', { defaultValue: 'Customer Service' })}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-charcoal-medium">
              <li>
                <button
                  onClick={() => openLegalPage('shipping')}
                  className="hover:text-green-dark transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.customer.shipping', { defaultValue: 'Shipping & Returns' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('withdrawal')}
                  className="hover:text-green-dark transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.customer.withdrawal', { defaultValue: 'Right of Withdrawal' })}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="min-w-0">
            <h3 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-charcoal-dark">
              {t('footer.contact.title', { defaultValue: 'Contact' })}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-charcoal-medium">
              <li className="leading-relaxed break-words" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>{t('footer.contact.email', { defaultValue: 'Email: siellamapposters@gmail.com' })}</li>
              <li className="leading-relaxed break-words">{t('footer.contact.address', { defaultValue: 'Tampere, Finland' })}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-wood-warm/30 pt-4 sm:pt-6 mt-4 sm:mt-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-charcoal-medium">
            <p className="text-center sm:text-left">
              © {currentYear} {t('footer.copyright', { defaultValue: 'Siella. All rights reserved.' })}
            </p>
            <div className="flex gap-3 sm:gap-4 items-center">
              <button
                onClick={() => openLegalPage('privacy')}
                className="hover:text-green-dark transition-colors min-h-[44px] sm:min-h-0 px-2 sm:px-0 flex items-center"
              >
                {t('footer.legal.privacy', { defaultValue: 'Privacy' })}
              </button>
              <span className="hidden sm:inline">•</span>
              <button
                onClick={() => openLegalPage('terms')}
                className="hover:text-green-dark transition-colors min-h-[44px] sm:min-h-0 px-2 sm:px-0 flex items-center"
              >
                {t('footer.legal.terms', { defaultValue: 'Terms' })}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
